// extracted by mini-css-extract-plugin
export var filterIncDec = "_43-0";
export var leftBorder = "_43-1";
export var rightBorder = "_43-2";
export var stringInput = "_43-3";